module.exports = __webpack_public_path__ + "static/sofiapro-500-fababf61daae2be5855ff2b51a05589f.woff";